export default __webpack_public_path__ + "static/media/945.ee8c265d.gif";